export default __webpack_public_path__ + "static/media/ellipse_wallet_3.b41e51ea.svg";